import { prefetchPathname } from "gatsby"
import React, { useEffect, useState } from "react"
import {
    MdKeyboardArrowDown,
    MdKeyboardArrowUp,
} from "react-icons/md"
import * as styles from "./DesktopMenuVersion1.module.scss"
import { Link, navigate } from "gatsby"
import { useLink, useSiteQuery } from "../../../../hooks/index"
import { GatsbyImage } from "gatsby-plugin-image"
import { useHeaderContext } from "../../../../hooks/layout/HeaderContext"
import { useSiteQueryThree } from "../../../../hooks/layout/useSiteQueryThree"
import debounce from "lodash.debounce"
import { useCallback } from "react"
import HeaderImageSlider from "../../../HeaderImageSlider/HeaderImageSlider"
// import HeaderImageSlider from "../../../HeaderImageSlider/HeaderImageSlider"

const DesktopMenuVersion1 = ({ menuItems }) => {
    const {
        quoteSection,
        headerBlogTitle,
        headerButton,
        headerBlogMedia,
        quoteSectionTitle,
    } = useSiteQuery()
    const {
        openDropdown,
        setOpenDropdown,
        childOpenState,
        setChildOpenState,
        subChildOpenState,
        setSubChildOpenState,
        handleLinkClick,
    } = useHeaderContext()

    const [searchTerm, setSearchTerm] = useState("")
    const [searchResults, setSearchResults] = useState([])

    const findId = (title) => {
        if (!title || typeof title !== "string") return ""
        return title.split(" ").join("-").toLowerCase()
    }

    const initialOpen = menuItems[0]?.children?.length
        ? findId(menuItems[0].children[0].title)
        : ""

    const handleMegaMenuClick = (id) => {
        setOpenDropdown(openDropdown === id ? "" : id)
        setChildOpenState(initialOpen)
        setSubChildOpenState("")
    }

    const handleParentClick = (id) => {
        setOpenDropdown(openDropdown === id ? "" : id)
        setChildOpenState(initialOpen)
        setSubChildOpenState("")
    }

    const debouncedSearch = useCallback(
        debounce((value, items, setResults) => {
            const results = []

            const searchMenu = (items) => {
                for (const item of items) {
                    if (item.title.toLowerCase().includes(value.toLowerCase())) {
                        results.push({ title: item.title, slug: item.slug })
                    }
                    if (item.children) {
                        searchMenu(item.children)
                    }
                }
            }

            searchMenu(items)
            setResults(results)
        }, 200),
        []
    )

    const handleSearchChange = (e) => {
        const value = e.target.value
        setSearchTerm(value)

        if (!value) {
            setSearchResults([])
            return
        }

        const results = []

        const searchMenu = (items) => {
            for (const item of items) {
                if (item.title.toLowerCase().includes(value.toLowerCase())) {
                    results.push({ title: item.title, slug: item.slug })
                }
                if (item.children) {
                    searchMenu(item.children)
                }
            }
        }

        searchMenu(menuItems)
        setSearchResults(results)


        results.forEach((result) => {
            const localizedLink = useLink(result.slug)
            prefetchPathname(localizedLink)
        })
    }



    const handleResultClick = (slug) => {
        navigate(useLink(slug))
        setSearchTerm("")
        setSearchResults([])
    }

    useEffect(() => {
        const hasDropdown = menuItems.some(
            (item) => findId(item.title) === openDropdown && item.children?.length > 0
        )

        if (hasDropdown) {
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
            document.body.style.overflow = "hidden"
            document.body.style.paddingRight = `${scrollbarWidth}px`
            document.getElementById("main").classList.add("blurredBackground")

            if (window.lenis) {
                window.lenis.stop()
            }
        } else {
            document.body.style.overflow = ""
            document.body.style.paddingRight = ""
            document.getElementById("main").classList.remove("blurredBackground")

            if (window.lenis) {
                window.lenis.start()
            }
        }

        return () => {
            document.body.style.overflow = ""
            document.body.style.paddingRight = ""
            document.getElementById("main").classList.remove("blurredBackground")

            if (window.lenis) {
                window.lenis.start()
            }
        }
    }, [openDropdown, menuItems])

    let timeoutId: NodeJS.Timeout;


    return (
        <nav className="hidden desktop">
            <div
                className={ styles.navigation }
                onMouseEnter={ () => {
                    clearTimeout(timeoutId);
                } }
                onMouseLeave={ () => {
                    timeoutId = setTimeout(() => {
                        setOpenDropdown("");
                        setChildOpenState("");
                        setSubChildOpenState("");
                    }, 200);
                } }
            >
                <div className={ styles.parentWrapper }>
                    <ul className={ styles.parent }>
                        { menuItems.map((menuItem) => {
                            // const newSlug =
                            //     menuItem.slug[0] === "/" ? menuItem.slug.slice(1) : menuItem.slug
                            // // const localizedPath = useLink(`/${newSlug}`)

                            return (
                                <li
                                    key={ findId(menuItem.title) }
                                    className={ `flex ${openDropdown === findId(menuItem.title) ? styles.active : ""
                                        }` }
                                    onMouseEnter={ () => {
                                        const id = findId(menuItem.title)
                                        if (openDropdown !== id) {
                                            setOpenDropdown(id)
                                            setChildOpenState(initialOpen)
                                            setSubChildOpenState("")
                                        }
                                    } }

                                >
                                    <Link to={ `/${useLink(menuItem.slug)}` }>
                                        { menuItem.title }
                                    </Link>
                                    { menuItem.children.length > 0 && (
                                        <button className={ styles.arrowButton } aria-label="Expand menu">
                                            { openDropdown === findId(menuItem.title) ? (
                                                <MdKeyboardArrowUp />
                                            ) : (
                                                <MdKeyboardArrowDown />
                                            ) }
                                        </button>
                                    ) }

                                    { menuItem.type !== "megamenu" &&
                                        openDropdown === findId(menuItem.title) &&
                                        menuItem.children.length > 0 && (
                                            <div className={ styles.defaultDropdown }>
                                                <ul>
                                                    { menuItem.children.map((child) => {
                                                        const childSlug =
                                                            child.slug[0] === "/" ? child.slug.slice(1) : child.slug
                                                        const childPath = useLink(`/${childSlug}`)

                                                        return (
                                                            <li key={ findId(child.title) }>
                                                                <div className={ styles.menuItem }>
                                                                    <div className={ styles.menuTitle }>
                                                                        <div className={ styles.title }>
                                                                            <Link
                                                                                to={ `/${useLink(child.slug)}` }
                                                                                onClick={ handleLinkClick }
                                                                            >
                                                                                { child.title }

                                                                                <p className={ styles.subTitle }>
                                                                                    { child.subTitle }
                                                                                </p></Link>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        )
                                                    }) }
                                                </ul>
                                                <div className={ styles.quote2 }>
                                                    <p>Inspired? Let’s connect and make it happen!</p>
                                                    <Link
                                                        to={ `${useLink("/contact-us")}` }
                                                        aria-label="Contact Us"
                                                        className={ `onPrimaryOutline ${styles.btn}` }
                                                    >
                                                        Get a Quote
                                                    </Link>
                                                </div>
                                            </div>
                                        ) }
                                </li>
                            )
                        }) }
                    </ul>

                    <ul>
                        { headerButton?.map((item, index) => {
                            // const localizedSlug = useLink(item.slug)
                            return (
                                <li key={ item.id || item.slug || item.title }>
                                    <Link
                                        to={ `/${useLink(item.target?.slug || item.slug)}` }
                                        className={ index === 0 ? "primaryFilled" : "" }
                                        title={ `Go to ${item.title}` }
                                    >
                                        { item.title }
                                    </Link>
                                </li>
                            )
                        }) }
                    </ul>
                </div>
                { menuItems.map(
                    (menuItem) =>
                        menuItem.type === "megamenu" &&
                        openDropdown === findId(menuItem.title) &&
                        menuItems.find((item) => findId(item.title) === openDropdown)
                            ?.children.length > 0 && (
                            <div className={ styles.megaMenu }>
                                <div className={ `container global-spacing ${styles.megaMenuHeader}` }>
                                    <p className={ styles.categoryTitle }>All Services</p>
                                    <div className={ styles.searchWrapper }>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" className={ styles.searchIcon }>
                                            <mask id="mask0_7749_1843" style={ { maskType: "alpha" } } maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                                                <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
                                            </mask>
                                            <g mask="url(#mask0_7749_1843)">
                                                <path d="M19.6 21.5L13.3 15.2C12.8 15.6 12.225 15.9167 11.575 16.15C10.925 16.3833 10.2333 16.5 9.5 16.5C7.68333 16.5 6.14583 15.8708 4.8875 14.6125C3.62917 13.3542 3 11.8167 3 10C3 8.18333 3.62917 6.64583 4.8875 5.3875C6.14583 4.12917 7.68333 3.5 9.5 3.5C11.3167 3.5 12.8542 4.12917 14.1125 5.3875C15.3708 6.64583 16 8.18333 16 10C16 10.7333 15.8833 11.425 15.65 12.075C15.4167 12.725 15.1 13.3 14.7 13.8L21 20.1L19.6 21.5ZM9.5 14.5C10.75 14.5 11.8125 14.0625 12.6875 13.1875C13.5625 12.3125 14 11.25 14 10C14 8.75 13.5625 7.6875 12.6875 6.8125C11.8125 5.9375 10.75 5.5 9.5 5.5C8.25 5.5 7.1875 5.9375 6.3125 6.8125C5.4375 7.6875 5 8.75 5 10C5 11.25 5.4375 12.3125 6.3125 13.1875C7.1875 14.0625 8.25 14.5 9.5 14.5Z" fill="#97A3B7" />
                                            </g>
                                        </svg>
                                        <input
                                            type="text"
                                            placeholder="SEARCH"
                                            value={ searchTerm }
                                            onChange={ handleSearchChange }
                                            onKeyDown={ (e) => {
                                                if (e.key === "Enter" && searchResults.length > 0) {
                                                    const firstResult = searchResults[0]
                                                    const localizedLink = useLink(firstResult.slug)
                                                    setSearchTerm("")
                                                    setSearchResults([])
                                                    setOpenDropdown("")
                                                    setTimeout(() => navigate(localizedLink), 0)
                                                }
                                            } }
                                            className={ styles.searchInput }
                                        />

                                        { searchResults.length > 0 && (
                                            <ul className={ styles.searchResults }>
                                                { searchResults.map((result, idx) => {
                                                    const localizedLink = useLink(result.slug)
                                                    return (
                                                        <li key={ idx }>
                                                             <Link
                                                                to={`/${useLink(result.slug)}`}
                                                                onClick={() => {
                                                                    setSearchTerm("")
                                                                    setSearchResults([])
                                                                    setOpenDropdown("")
                                                                }}
                                                            >
                                                                { result.title }
                                                            </Link>
                                                        </li>
                                                    )
                                                }) }
                                            </ul>

                                        ) }


                                    </div>
                                </div>
                                <div className={ styles.advImgWrapper }>
                                    <div className={ styles.menuContainer }>
                                        {/* LEVEL 1 */ }
                                        <div className={ styles.level1 }>
                                            <ul>
                                                { menuItems
                                                    .find((item) => findId(item.title) === openDropdown)
                                                    ?.children.map((item) => (
                                                        <li
                                                            key={ findId(item.title) }
                                                            className={
                                                                childOpenState === findId(item.title)
                                                                    ? styles.active
                                                                    : ""
                                                            }
                                                            onMouseEnter={ () => {
                                                                setChildOpenState(findId(item.title))
                                                                setSubChildOpenState("")
                                                            } }
                                                        >
                                                            <div className={ styles.menuItem }>
                                                                <div className={ styles.menuTitle }>
                                                                    <div>
                                                                        {/* <Link to={ useLink(item.slug) } onClick={ handleLinkClick }>
                                                                            { item.title }
                                                                        </Link> */}
                                                                        <Link
                                                                            to={ `/${useLink(item.slug)}` }
                                                                            onClick={ handleLinkClick }
                                                                        >
                                                                            { item.title }
                                                                        </Link>
                                                                        <p className={ styles.subTitle }>{ item.subTitle }</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    )) }
                                            </ul>
                                        </div>

                                        {/* LEVEL 2 + LEVEL 3 */ }
                                        <div className={ styles.level2 }>
                                            <ul>
                                                <li>
                                                    { menuItems
                                                        .find((item) => findId(item.title) === openDropdown)
                                                        ?.children.find((child) => findId(child.title) === childOpenState)
                                                        ?.children?.map((child, idx) => {
                                                            const childId = findId(child.title)
                                                            return (
                                                                <div
                                                                    key={ idx }
                                                                    className={ `${styles.menuItem} ${subChildOpenState === childId ? styles.active : ""}` }
                                                                    onMouseEnter={ () => setSubChildOpenState(childId) }
                                                                >
                                                                    <div className={ styles.menuTitle }>
                                                                        <div>
                                                                            {/* <Link to={ useLink(child.slug) } onClick={ handleLinkClick }>
                                                                                { child.title }
                                                                            </Link> */}
                                                                            <Link
                                                                                to={ `/${useLink(child.slug)}` }
                                                                                onClick={ handleLinkClick }
                                                                            >
                                                                                { child.title }
                                                                            </Link>
                                                                            <p className={ styles.subTitle }>{ child.subTitle }</p>
                                                                        </div>
                                                                    </div>

                                                                    { child.children?.length > 0 && (
                                                                        <div className={ styles.level3Content }>
                                                                            <div className={ styles.level3Tags }>
                                                                                { child.children.map((subChild, i) => (
                                                                                    <Link
                                                                                        key={ i }
                                                                                        to={ `/${useLink(subChild.slug)}` }
                                                                                        onClick={ handleLinkClick }
                                                                                        className={ styles.tagButton }
                                                                                    >
                                                                                        { subChild.title }
                                                                                    </Link>
                                                                                )) }
                                                                            </div>
                                                                        </div>
                                                                    ) }
                                                                </div>
                                                            )
                                                        }) }
                                                </li>
                                            </ul>
                                        </div>

                                        {/* IMAGE + SNIPPET */ }
                                        <div className={ styles.level3Box }>
                                            <HeaderImageSlider data={ headerBlogMedia } />
                                        </div>
                                    </div>

                                    {/* QUOTE */ }
                                    <div className={ `flex justify-between ${styles.quote}` }>
                                        <p>{ quoteSectionTitle }</p>
                                        <button>
                                            { quoteSection.map((item, index) => (
                                                <li key={ item.id || item.slug || item.title }>
                                                    <Link
                                                        // to={ useLink(item.slug) }
                                                        to={ `/${useLink(
                                                            item.target?.slug || item.slug
                                                        )}` }
                                                        className={ index === 0 ? `${styles.primaryFilledNew}` : "" }
                                                        title={ `Go to ${item.title}` }
                                                        onClick={ handleLinkClick }
                                                    >
                                                        { item.title }
                                                    </Link>
                                                </li>
                                            )) }
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )
                ) }
            </div>
        </nav>
    )
}

export default DesktopMenuVersion1